import Colors from 'enums/Colors';
import styled from 'styled-components';

const AdminFVContainerStyled = {
    Container: styled.div<{ img?: string }>`
        /* Exibe gradiente horizontal, gradiente vertical, imagem e cor sólida */
        background: ${props =>
            props.img
                ? `
                    linear-gradient(270deg, rgba(0, 60, 120, 0.4) 0%, #003c78 90%),
                    linear-gradient(180deg, rgba(0, 60, 120, 0.4) 0%, #003c78 100%),
                    url(${props.img}), #003c78
                `
                : `
                  linear-gradient(270deg, rgba(0, 60, 120, 0.4) 0%, #003C78 70%);

                    
                `};
        background-repeat: no-repeat, no-repeat, no-repeat, repeat;
        background-size: 100%;
        background-position: top, top, top, top;
        color: white;
        padding: 32px 329px;
        display: flex;
        flex-direction: column;
        gap: 24px;
        min-height: 100vh;

        section {
            display: flex;
            flex-direction: column;
            gap: 16px;
        }

        @media screen and (max-width: 1900px) {
            padding: 32px 24px;
        }

        @media screen and (max-width: 768px) {
            padding: 16px;
        }
    `,

    Video: {
        Container: styled.div`
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            width: 885px;
            height: 498px;
            background-color: #00000055;
        `,
    },

    ErrorText: styled.span`
        color: ${Colors.Red};
        font-size: 0.875rem;
    `,

    Title: styled.h1`
        font-size: 1.5rem;
        font-weight: bold;
        margin: 0;
    `,

    DivBetween: styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        padding: 24px;
    `,

    FormTwoGrid: styled.div`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 24px;
    `,

    FormGroup: styled.div`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,

    Label: styled.label`
        font-size: 1rem;
        font-weight: 500;
        color: ${Colors.Blue};
    `,

    Input: styled.input`
        padding: 10px 14px;
        border-radius: 6px;
        border: none;
        font-size: 1rem;
        background: #f5f7fa;
        color: #003c78;
        outline: none;
        transition: box-shadow 0.2s;
        &:focus {
            box-shadow: 0 0 0 2px #ffb300;
        }
    `,

    TextArea: styled.textarea`
        padding: 10px 14px;
        border-radius: 6px;
        border: none;
        font-size: 1rem;
        background: #f5f7fa;
        color: #003c78;
        outline: none;
        min-height: 80px;
        resize: vertical;
        transition: box-shadow 0.2s;
        &:focus {
            box-shadow: 0 0 0 2px #ffb300;
        }
    `,

    Select: styled.select`
        padding: 10px 14px;
        border-radius: 6px;
        border: none;
        font-size: 1rem;
        background: #f5f7fa;
        color: #003c78;
        outline: none;
        transition: box-shadow 0.2s;
        &:focus {
            box-shadow: 0 0 0 2px #ffb300;
        }
    `,

    Button: styled.button`
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(90deg, #ffb300 0%, #ffcb3a 100%);
        color: #003c78;
        font-weight: bold;
        font-size: 1.1rem;
        border: none;
        border-radius: 6px;
        padding: 12px 0;
        margin-top: 12px;
        cursor: pointer;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
        transition: background 0.2s, color 0.2s;
        text-transform: uppercase;
        max-width: 260px;
        &:hover {
            background: linear-gradient(90deg, #ffcb3a 0%, #ffb300 100%);
            color: #00264d;
        }
    `,

    Card: {
        Container: styled.div`
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            gap: 16px;
            background: white;
            border-radius: 12px;
            width: 300px;
            min-height: 180px;
            padding: 16px;
            box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;
            cursor: pointer;
            z-index: 0;

            &:hover {
                transform: translateY(-4px);
                box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
            }

            img {
                height: 140px;
                width: 100%;
                object-fit: contain;
            }

            h1 {
                color: ${Colors.Blue};
                font-size: 26px;
                font-weight: 700;
            }

            p {
                color: ${Colors.BlueGrey};
                font-size: 16px;
                font-weight: 400;
                line-height: 18px;
                max-width: 100%;
            }
        `,
    },

    ContainerPage: {
        Content: styled.div`
            display: flex;
            flex-direction: column;
            gap: 24px;
            padding: 24px;
            color: ${Colors.White};
        `,

        LogoSolucao: styled.img`
            max-width: 160px;
            background-color: #f6f6f6;
            padding: 10px;
            border-radius: 20px;
            height: auto;
        `,

        Title: styled.h1`
            font-family: 'Barlow';
            font-weight: 700;
            font-style: Bold;
            font-size: 40px;
            line-height: 150%;
            letter-spacing: -1%;
            vertical-align: middle;
            text-transform: uppercase;
        `,

        Description: styled.p`
            font-family: 'Barlow';
            font-weight: 500;
            font-style: Medium;
            font-size: 24px;
            line-height: 150%;
            letter-spacing: -1%;
            vertical-align: middle;

            max-width: 600px;
        `,
    },

    Row: styled.div`
        display: flex;
        align-items: center;
        gap: 16px;
    `,
};

export default AdminFVContainerStyled;
